export const energyReplacePages =
  [
     {
      page: 'subscribersPage',
      percent: 25,
    },
        {
      page: 'packagesPage',
      percent: 50,
    },
    {
      page: 'sendAgreementPage',
      percent: 75,
    },
    {
      page: 'successPage',
      percent: 100,
    },
  ];

